import StockOpnameDetail from '@/models/StockOpname/StockOpnameDetail';

export default class StockOpnameDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.stockOpnameId  = '';
		this.stockOpnameStockOpnamePlan = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partLabel = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.caseQty = '';
		this.qtyActual = '';
		this.remarksMultiple = '';
		this.scannedById  = '';
		this.scannedByFirstName = '';
		this.userIdCard = '';
		this.isFromUpload = false;
		this.isScanned = '';
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			stockOpnameId : '0',
			stockOpnameStockOpnamePlan : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partLabel : '0',
			partId : '0',
			partPartNumber : '0',
			caseQty : '0',
			qtyActual : '0',
			remarksMultiple : '0',
			scannedById : '0',
			scannedByFirstName : '0',
			userIdCard : '0',
			isFromUpload : '0',
			isScanned : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}